export enum LibLinkTrust {
  Fully = 0,
  Download = 1,
  NoDownload = 2,
  Content = 3,
}

export enum AssetPriceType {
  FOC = 0,
  Once = 1,
  EachTime = 2,
}

export enum GuestWorkflowMode {
  DISABLED = 0,
  OFF = 1,
  PROMPT = 2,
  AUTOMATIC = 3,
}

export enum DragAndDropNames {
  NONE = 'None',
  PAGE = 'Page',
}

export enum KeyboardKeys {
  ARROWUP = 'ArrowUp',
  ARROWDOWN = 'ArrowDown',
  ARROWLEFT = 'ArrowLeft',
  ARROWRIGHT = 'ArrowRight',
  ENTER = 'Enter',
  ESCAPE = 'Escape',
  DOT = '.',
  TAB = 'Tab',
  SPACE = ' ',
}

export enum UpgradeLayoutStage {
  None = 0,
  Creation = 1,
  Order = 2,
}

export enum OptionsAndExtrasCloseMode {
  Close,
  Order,
}

export enum OptionsAndExtrasDisplayStage {
  None,
  Start,
  Order,
  All,
}

export enum OptionsAndExtrasValidateMode {
  None,
  ValidateAll,
  ValidateAllComponentsCheckOnly,
  ValidateOne,
}

export enum OptionControlType {
  Radio = 'radio',
  Checkbox = 'checkbox',
}

export enum OptionControlLayout {
  List = 'list',
  Tiled = 'vertical',
}

export enum KeywordType {
  'Checkbox' = 'CHECKBOX',
  'Multiline' = 'MULTILINE',
  'Popup' = 'POPUP',
  'RadioGroup' = 'RADIOGROUP',
  'Singleline' = 'SINGLELINE',
}

export enum KeywordFlags {
  UpperCase = 'U',
  Required = 'M',
}

export enum PricingModel {
  NoPricing = 0,
  PerQuantity = 3,
  PerSideQuantity = 5,
  PerProductComponentQuantity = 7,
  PerSidePerProductPerComponentQuantity = 8,
}

export enum ThreeDPreviewStatus {
  None = 'none',
  Loading = 'loading',
  Loaded = 'loaded',
}

export enum OpenMode {
  New = 2,
  Existing = 3,
  Preview = 5,
}

export enum DialogStatus {
  Closed = 'closed',
  Open = 'open',
  Seen = 'seen',
}

export enum OrderCartMethod {
  PostMessage = 'postmessage',
}

export enum OrderStatus {
  Order = 'ORDER',
  Upload = 'UPLOAD',
  Error = 'ERROR',
  Message = 'MESSAGE',
}

export enum ProductOrienation {
  Square = 0,
  Landscape = 1,
  Portrait = 2,
}
